import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/Slices/modalSlice";

import './scss/BaordSection.scss'
import MemberImage from "../Global/MemberImage";
import StarFill from "../icons/StarFill";
import { config } from "../../config";
import { fetchStarredBoards } from "../../redux/Slices/boardsSlice";
import { fetchUser } from "../../redux/Slices/thunks";
import MoreMembersCount from "../Global/MoreMembersCount";
import { api } from "../../utils/apiUtils";
import Add from "../icons/Add";
import BoardGridItem from "./BoardGridItem";

const BoardSection = ({ workspace, defaultSelectedOption, isGuests }) => {
    const { boards } = workspace;
    const [displayedBoards, setDisplayedBoards] = useState(boards || []);

    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.user);
    const isUserLoaded = user && user.user;

    const handleCreateBoard = (defaultSelectedOption) => {
        dispatch(openModal({ modalType: 'CREATE_BOARD', modalData: { defaultSelectedOption } }));
    };


    // Optimized toggle star function using our API utility
    const toggleStar = async (boardId, shortId) => {
        if (!isUserLoaded) {
            console.warn('User data not loaded yet');
            return;
        }

        try {
            const isStarred = user?.user?.starredBoards?.includes(boardId);
            const action = isStarred ? 'remove' : 'add';

            // Use our optimized API utility
            await api.put(`${config.API_URI}/v1/users/me/stared`,
                { boardId: shortId, action }
            );

            // Refresh data in Redux store
            dispatch(fetchStarredBoards());
            dispatch(fetchUser());
        } catch (error) {
            console.error('Error toggling star status:', error);
        }
    };


    // Initialize with the boards from props
    useEffect(() => {
        setDisplayedBoards(boards || []);
    }, [boards]);

    // Render board items
    const renderBoardItem = (board) => {
        return (
            <BoardGridItem
                key={board._id}
                board={board}
                workspace={workspace}
                isGuests={isGuests}
                isUserLoaded={isUserLoaded}
                user={user}
                toggleStar={toggleStar}
            />
        );
    };

    return (
        <div className="boards-page-board-section-list">
            {/* Render boards */}
            {displayedBoards?.map(renderBoardItem)}

            {/* Create board button */}
            {!isGuests && (
                <div className="create-board" onClick={() => { handleCreateBoard(defaultSelectedOption) }}>
                    <div className="create-board-content">
                        <Add size={28} />
                        <span className="create-board-text">Create new board</span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default BoardSection;